import request from '../request';
export const uploadFile = (file) => {
    return new Promise((resolve, reject) => {
        request.post('file/upload', file).then((response) => {
            resolve(response?.data);
        }).catch(function (err) {
            reject(err);
        });
    });
};
export const checkFileUpdated = (file) => {
    return new Promise((resolve, reject) => {
        request.post('/file/check', file).then((response) => {
            resolve(response?.data);
        }).catch(function (err) {
            reject(err);
        });
    });
};
export const removeFile = (file) => {
    return new Promise((resolve, reject) => {
        request.post('file/remove', file).then((response) => {
            resolve(response?.data);
        }).catch(function (err) {
            reject(err);
        });
    });
};
// 将指定数据标记为已完成编辑
export const completeFile = (file) => {
    return new Promise((resolve, reject) => {
        request.post('/file/complete', file).then((response) => {
            resolve(response?.data);
        }).catch(function (err) {
            reject(err);
        });
    });
};
